import { useMoveStore } from '../store/moveStore'

interface MoveViewProps {
  currentCount?: number
  totalCount: number
  callback?: () => void
}

export default function MoveView (props: MoveViewProps) {
  const [movementIsLocked] = useMoveStore((state) => [state.movementIsLocked, state.lockMovement, state.unlockMovement])
  const [animationStep, increaseAnimationStep, resetAnimationStep] = useMoveStore((state) => [state.animationStep, state.increaseAnimationStep, state.resetAnimationStep])

  const getCountString = () => {
    return `${animationStep}/${props.totalCount}`
  }

  const handleButtonClick = () => {
    if (!movementIsLocked) {
      if (animationStep + 1 > props.totalCount) {
        resetAnimationStep()
        increaseAnimationStep()
      } else {
        increaseAnimationStep()
      }

      if (props.callback) props.callback()
    }
  }

  return (
    <div className="absolute w-full h-full top-0 left-0 pointer-events-none">
      <div className="pointer-events-auto absolute bottom-0 w-full flex justify-center text-center">
        <div className='relative'>
          <button className={'btn--blue w-[360px] m-[15px] mb-[20px] mt-[0px] z-[2] relative'}
                  onClick={handleButtonClick}
                  disabled={movementIsLocked}>
            Move
          </button>

          {props.totalCount &&
            <div className='flex justify-center absolute inset-0 z-[1]'>
              <div
                className='flex text-[#0350A8] text-lg justify-center w-[60px] h-[60px] bg-[#D9D9D9] rounded-full -mt-8'>
                <span className='mt-1'>{getCountString()}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
}
